import { TOnboardingType } from 'shared/domain/entities';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import { IFacialRecognitionsRepository } from 'shared/domain/repositories';
import {
  FacialRecognition,
  IVectisFacialRecognition,
  TVectisOnboardingType,
} from 'shared/infra/adapters';

const ONBOARDING_TYPE_DICTIONARY: Record<
  TOnboardingType,
  TVectisOnboardingType
> = {
  DOCUMENTOSCOPY: 'DOCUMENTOSCOPIA',
  FACIAL_BIOMETRY: 'BIOMETRIA_FACIAL',
  ONE_FOR_ONE_BIOMETRY: 'BIOMETRIA_FACIAL_ONE_FOR_ONE',
};

export class VectisFacialRecognitionsRepository
  implements IFacialRecognitionsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findOne: IFacialRecognitionsRepository['findOne'] = async ({
    process,
    onboardingType,
  }) => {
    const params = process.params;
    if (onboardingType) {
      params.tipoOnboarding = ONBOARDING_TYPE_DICTIONARY[onboardingType];
    }

    const recognition = await this.httpProvider.get<IVectisFacialRecognition>(
      process.url,
      {
        params,
      },
    );

    return new FacialRecognition(recognition);
  };
}
